import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";

const FEATURES = [
  {
    tag: "Invest in Goa",
    title: "Resorts, beachfront developments & tourism infrastructure",
    body: "Premium hospitality opportunities ready for global capital — boutique resorts, beach clubs, and integrated tourism infrastructure.",
    img: "https://images.pexels.com/photos/5231168/pexels-photo-5231168.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    span: "lg:col-span-8 lg:row-span-2",
    big: true,
  },
  {
    tag: "Goa Global Showcase",
    title: "Premium Goa brands going international",
    body: "Curated ventures positioned for global expansion.",
    span: "lg:col-span-4",
  },
  {
    tag: "Goa Export Connect",
    title: "Connect with global buyers & distributors",
    body: "Enable Goa-based products to reach international markets.",
    span: "lg:col-span-4",
  },
];

export const GlobalShowcase = () => {
  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="relative bg-[#02060D] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-8">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-[0.3em] uppercase text-[#D1B677] font-medium">
                Global Showcase · Invest in Goa · Export Connect
              </span>
            </div>
            <h2 className="font-serif text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
              Premium ventures.{" "}
              <span className="italic text-[#D1B677]">Goa's global frontier.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 auto-rows-[280px]">
          {FEATURES.map((f, i) => (
            <motion.a
              key={i}
              href="#register"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`showcase-card-${i}`}
              className={`${f.span} group relative overflow-hidden border border-white/8 hover:border-[#D1B677]/40 transition-all duration-500`}
            >
              {f.img && (
                <div className="absolute inset-0">
                  <img
                    src={f.img}
                    alt={f.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#02060D] via-[#02060D]/60 to-[#02060D]/10" />
                </div>
              )}
              {!f.img && (
                <div className="absolute inset-0 bg-gradient-to-br from-[#0C5A48]/30 via-[#050B14] to-[#02060D]" />
              )}

              <div className="relative z-10 p-8 lg:p-10 h-full flex flex-col justify-between">
                <div className="flex justify-between items-start">
                  <span className="text-[10px] tracking-[0.3em] uppercase text-[#D1B677] font-medium">
                    {f.tag}
                  </span>
                  <ArrowUpRight
                    size={20}
                    weight="light"
                    className="text-[#D1B677] opacity-0 group-hover:opacity-100 group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-500"
                  />
                </div>
                <div>
                  <h3
                    className={`font-serif text-white ${
                      f.big ? "text-2xl lg:text-4xl" : "text-xl lg:text-2xl"
                    } leading-tight mb-3`}
                  >
                    {f.title}
                  </h3>
                  <p className="text-sm text-[#A1AEBF] leading-relaxed max-w-md">
                    {f.body}
                  </p>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GlobalShowcase;
